import { useLocation } from 'react-router-dom'
import { useTheme } from '../../context/ThemeContext'
import {
  Bars3Icon,
  SunIcon,
  MoonIcon,
  ArrowDownTrayIcon
} from '@heroicons/react/24/outline'

const pageTitles = {
  '/revenue/overview': 'Revenue Overview',
  '/revenue/country': 'Revenue Country Report',
  '/revenue/customer': 'Revenue Customer Report',
  '/marketing/overview': 'Marketing & Sales Overview',
  '/marketing/deals': 'Marketing & Sales Deals',
  '/financial/overview': 'Financial Targets Overview',
  '/financial/mom': 'Financial Targets MoM',
  '/onboarding': 'Onboarding Dashboard'
}

export default function Header({ onMenuClick, onExport }) {
  const location = useLocation()
  const { theme, toggleTheme } = useTheme()

  const title = pageTitles[location.pathname] || 'Dashboard'

  return (
    <header className="sticky top-0 z-30 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      <div className="flex items-center justify-between h-16 px-4 sm:px-6">
        <div className="flex items-center gap-4">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg"
          >
            <Bars3Icon className="w-6 h-6" />
          </button>
          <h1 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white">
            {title}
          </h1>
        </div>

        <div className="flex items-center gap-2">
          {onExport && (
            <button
              onClick={onExport}
              className="hidden sm:flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors"
            >
              <ArrowDownTrayIcon className="w-4 h-4" />
              Export PDF
            </button>
          )}

          <button
            onClick={toggleTheme}
            className="p-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
            title={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
          >
            {theme === 'light' ? (
              <MoonIcon className="w-5 h-5" />
            ) : (
              <SunIcon className="w-5 h-5" />
            )}
          </button>
        </div>
      </div>
    </header>
  )
}
